module.exports = __webpack_public_path__ + "static/media/prv6.eb167e85.jpg";